import { useContext, useEffect } from "react";
import { Outlet } from "react-router-dom";
import { Container, Typography } from "@mui/material";

import { BrandContext } from "../../App";
import LandingLayout from "../Layout/Layout";
import theme from "../../Theme";

import ScrollToTop from "../helpers/ScrollToTop";

import { useUI } from "../../contexts/UIContext";

export default function Dashboard() {
  const { brand } = useContext(BrandContext);

  const { showFooter, setSideMenuOpen } = useUI();

  useEffect(() => {
    setSideMenuOpen(false);
    return () => {
      setSideMenuOpen(true);
    };
  }, []);

  return (
    <>
      <ScrollToTop />
      <LandingLayout>
        <div className="app-inner-container">
          <Outlet />
          {showFooter && (
            <Typography
              variant="body2"
              color="text.secondary"
              sx={{
                mt: theme.containers.paddingDesktop,
                width: "100%",
                bottom: 5,
                textAlign: "center",
              }}
            >
              {"© "}
              {brand.name} {new Date().getFullYear()}
            </Typography>
          )}
        </div>
      </LandingLayout>
    </>
  );
}
